module.exports = __webpack_public_path__ + "static/img/anxun82.59fc940d.png";